/**
 * A failed HTTP response, with its status kept as a FIELD rather than only in
 * the message text.
 *
 * The reason this class exists: a rejected save has to be told apart from a
 * crashed server. Before this, `BackendClient.request()` threw a plain `Error`
 * whose message merely mentioned the status, and the command bus swallowed that
 * into a boolean — so by the time any caller saw anything, a 409 ("somebody else
 * holds the lock, nothing was saved") was indistinguishable from a 500.
 *
 * Strictly additive: the message text is unchanged, so the existing callers that
 * parse it (e.g. the axis data service's `message.includes('status 404')`) keep
 * working exactly as before.
 */
export class HttpError extends Error {

    /**
     * @param serverCode    `error.code` of the backend's error body, when it sent one (a refused
     *                      command answers 500 with `{success: false, error: {code, message}}`)
     * @param serverMessage `error.message` of that body; kept apart from `message`, which stays the
     *                      transport text that existing callers parse
     */
    public constructor(
        message: string,
        public readonly status: number,
        public readonly serverCode?: number,
        public readonly serverMessage?: string,
    ) {
        super(message);
        this.name = 'HttpError';
    }

}
